'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobileDetect = require('mobile-detect');

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userAgent = (0, _get2.default)((0, _get2.default)(global, 'window', {}), 'navigator.userAgent', '');

exports.default = new _mobileDetect2.default(userAgent);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/internal/mobile-detect.js
// module id = 827
// module chunks = 0